import { render, staticRenderFns } from "./biographicalInformation.vue?vue&type=template&id=46e01596&scoped=true&"
import script from "./biographicalInformation.vue?vue&type=script&lang=js&"
export * from "./biographicalInformation.vue?vue&type=script&lang=js&"
import style0 from "./biographicalInformation.vue?vue&type=style&index=0&id=46e01596&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e01596",
  null
  
)

export default component.exports